import { Phone, Mail, MapPin } from "lucide-react";
import { CONTACT, NAV_LINKS, IMAGES } from "../../data/content";
import { scrollToId } from "../../hooks/useSmoothScroll";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer data-testid="site-footer" className="relative bg-[#08313F] text-slate-300">
      <div className="mx-auto max-w-7xl px-5 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="inline-flex items-center rounded-xl bg-white px-4 py-3">
              <img src={IMAGES.logo} alt="Tetőklinika logó" className="h-9 w-auto" />
            </div>
            <p className="mt-4 text-sm leading-relaxed text-slate-400 max-w-xs">
              Tetőfedés, tetőjavítás, tetőfelújítás, bádogos munkák és tetőszigetelés több mint 20 éves
              szakmai tapasztalattal.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-white">Menü</h4>
            <ul className="mt-4 space-y-2.5">
              {NAV_LINKS.map((l) => (
                <li key={l.id}>
                  <button data-testid={`footer-nav-${l.id}`} onClick={() => scrollToId(l.id)} className="text-sm text-slate-400 hover:text-emerald-400 transition-colors">
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-white">Elérhetőség</h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li className="flex items-start gap-2.5">
                <MapPin className="h-4 w-4 shrink-0 text-emerald-400 mt-0.5" />
                <span>{CONTACT.address}</span>
              </li>
              <li>
                <a href={CONTACT.phoneHref} data-testid="footer-phone" className="flex items-center gap-2.5 hover:text-emerald-400 transition-colors">
                  <Phone className="h-4 w-4 text-emerald-400" /> {CONTACT.phoneDisplay}
                </a>
              </li>
              <li>
                <a href={CONTACT.emailHref} data-testid="footer-email" className="flex items-center gap-2.5 hover:text-emerald-400 transition-colors">
                  <Mail className="h-4 w-4 text-emerald-400" /> {CONTACT.email}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-white">Cégadatok</h4>
            <ul className="mt-4 space-y-2 text-sm text-slate-400">
              <li>{CONTACT.company}</li>
              <li>Adószám: {CONTACT.taxNumber}</li>
              <li>Cégjegyzékszám: {CONTACT.regNumber}</li>
            </ul>
            <ul className="mt-4 space-y-2 text-sm">
              <li><a href="#adatkezeles" data-testid="footer-privacy" className="text-slate-400 hover:text-emerald-400 transition-colors">Adatkezelési tájékoztató</a></li>
              <li><a href="#impresszum" data-testid="footer-imprint" className="text-slate-400 hover:text-emerald-400 transition-colors">Impresszum</a></li>
              <li><a href="#cookie" data-testid="footer-cookies" className="text-slate-400 hover:text-emerald-400 transition-colors">Cookie-beállítások</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-500">© {year} Tetőklinika – {CONTACT.company}. Minden jog fenntartva.</p>
          <p className="text-xs text-slate-500">Nyugat-Magyarország · Dunántúl · Pest megye · Szlovákia</p>
        </div>
      </div>
    </footer>
  );
}
